var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Profile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.33,
    height: 20,
    viewBox: "0 0 17.33 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3386",
    "data-name": "Rectangle 3386",
    width: 17.33,
    height: 20,
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3577",
    "data-name": "Group 3577",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M.426,20A.757.757,0,0,1,0,19.194a7.677,7.677,0,0,1,6.248-7.357,9.4,9.4,0,0,1,1.32-.113c.776-.017,1.553-.027,2.328,0A7.384,7.384,0,0,1,16.485,15.9a7.531,7.531,0,0,1,.844,3.313A.735.735,0,0,1,16.9,20Zm.763-1.182H16.156c-.048-.289-.086-.564-.141-.836a6.407,6.407,0,0,0-6.06-5.088c-.872-.011-1.745-.014-2.617.006a5.447,5.447,0,0,0-1.124.135,6.312,6.312,0,0,0-4.6,3.959,5.939,5.939,0,0,0-.426,1.824",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M9.089,0c.411.092.833.15,1.232.281a5.286,5.286,0,0,1-.805,10.192,5.211,5.211,0,0,1-6-4.458A5.282,5.282,0,0,1,7.789.077c.151-.024.3-.051.453-.077ZM8.675,1.172a4.1,4.1,0,1,0,4.032,4.107A4.078,4.078,0,0,0,8.675,1.172",
    fill: "#333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.d45302b8fdec6d66d26bc0990b45d0b6.svg";
export { ForwardRef as ReactComponent };